import shareThis from 'share-this'
import * as emailSharer from './emailSharer'
import { trackHighlight } from './events'
import * as facebookSharer from './facebookSharer'
import * as twitterSharer from './twitterSharer'

const onOpen = () => trackHighlight('body')

export default function setupHighlightShare() {
  const isNotMobile =
    !window.matchMedia || !window.matchMedia('(pointer: coarse)').matches

  if (isNotMobile) {
    const selectionShare = shareThis({
      selector: '.highlight-shareable',
      sharers: [facebookSharer, twitterSharer, emailSharer],
      onOpen,
    })

    selectionShare.init()
  }
}
